module.exports = __webpack_public_path__ + "static/media/reviewTargetMobile.84fcace8.jpg";